(function(){
    'use strict'

    angular
    .module('app.bloqueos')
    .controller('BloqueosAdmin', BloqueosAdmin);

    BloqueosAdmin.$inject = ['$animationsSrv', 'BloqueoXUsuarioService', 'logger', '$location', 'UserInfoService'];

    function BloqueosAdmin($animationsSrv, BloqueoXUsuarioService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.bloqueos = [];
        vm.title = 'Bloqueos';

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = BloqueoXUsuarioService.getAll();

            promise
            .then(function(bloqueos){
                vm.bloqueos = bloqueos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los bloqueos.');
                        break;
                }
            });
        };

        vm.delete = function(bloqueo){
            var promise = BloqueoXUsuarioService.remove(bloqueo);
            
            promise
            .then(function(response){
                vm.bloqueos = vm.bloqueos.filter(function(g) {
                    return g.id !== bloqueo.id;
                });
                logger.success('Bloqueo eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Bloqueo');
                        break;
                }
                
            });   
        };

    }
})();